import { render, staticRenderFns } from "./YioksTipLoding.vue?vue&type=template&id=94e35560&scoped=true&"
import script from "./YioksTipLoding.vue?vue&type=script&lang=js&"
export * from "./YioksTipLoding.vue?vue&type=script&lang=js&"
import style0 from "./YioksTipLoding.vue?vue&type=style&index=0&id=94e35560&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e35560",
  null
  
)

export default component.exports